export default "__VITE_ASSET__f3e68130__"